module.exports = "\n<div :id=\"id\" class=\"g2-wrap\" :style=\"wrap\">\n  <div id=\"g2-wrap\"></div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/components/g2/src/index.vue
// module id = 2321
// module chunks = 38